import { Steps } from "antd";
import { renderInlineMarkdown } from "./inlineMd";

interface StepsBlockProps {
	items: { title: string; description?: string }[];
}

export default function StepsBlock({ items }: StepsBlockProps) {
	const rendered = items.map((item) => ({
		title: renderInlineMarkdown(item.title),
		description: item.description ? renderInlineMarkdown(item.description) : undefined,
	}));
	return (
		<div style={{ margin: "16px 0" }}>
			<Steps
				direction="vertical"
				size="small"
				current={-1}
				items={rendered}
			/>
		</div>
	);
}
